export default __webpack_public_path__ + "static/media/horizontal-dots.6d6385e8.svg";